import {ADD_IMAGE, SUCCESS, REMOVE_IMAGE} from "../constants/action-types";

export default (pictures = {}, action) => {
  const {type, response, payload} = action;
  switch (type) {
    case ADD_IMAGE + SUCCESS:
      return {
        ...pictures,
        images: [
          {
            id: response.id,
            type: response.picture_content_type,
            original: response.canvas_url,
            originalWidth: response.original_width,
            originalHeight: response.original_height,
            preview: response.small_url
          },
          ...pictures.images
        ]
      };
    case REMOVE_IMAGE + SUCCESS:
      return {
        ...pictures,
        images: pictures.images.filter((image) => image.id !== payload.id)
      };
  }
  return pictures;
};
